// Shared static content for NC&C Luxury
export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_ncc-luxury-transport/artifacts/j1zjl6dc_8cb744f3-d8be-4887-80f6-be1671738750%202.JPG",
  hero: "https://customer-assets.emergentagent.com/job_ncc-luxury-transport/artifacts/ol1zromh_ChatGPT%20Image%208%20lug%202026%2C%2015_35_51.png",
  fleet1: "https://images.pexels.com/photos/18370955/pexels-photo-18370955.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  fleet2: "https://images.pexels.com/photos/17455633/pexels-photo-17455633.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  amalfi: "https://images.pexels.com/photos/26976122/pexels-photo-26976122.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  sorrento: "https://images.pexels.com/photos/19143160/pexels-photo-19143160.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  positano: "https://images.pexels.com/photos/919280/pexels-photo-919280.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  pompeii: "https://images.pexels.com/photos/38135313/pexels-photo-38135313.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  chauffeur: "https://images.pexels.com/photos/7594130/pexels-photo-7594130.jpeg",
  interior: "https://images.pexels.com/photos/16716122/pexels-photo-16716122.jpeg",
};

export const CONTACT = {
  phone: "3288853609",
  phoneIntl: "+39 328 885 3609",
  whatsapp: "393288853609",
  email: "info@nccluxury.info",
  address: "Via Domenico Colasanto 15, 80126 Napoli",
  vat: "10252461214",
};

// Service icons use lucide-react names
export const services = [
  {
    key: "airport", icon: "Plane",
    it: { title: "Trasferimenti Aeroporto & Stazione", desc: "Servizio puntuale da e verso aeroporti e stazioni, con monitoraggio voli e accoglienza personalizzata." },
    en: { title: "Airport & Station Transfers", desc: "Punctual transfers to and from airports and stations, with flight monitoring and personalised welcome." },
  },
  {
    key: "chauffeur", icon: "UserRound",
    it: { title: "Autista Privato", desc: "Un chauffeur professionale a vostra completa disposizione, per ore o intere giornate." },
    en: { title: "Private Chauffeur", desc: "A professional chauffeur entirely at your disposal, by the hour or full day." },
  },
  {
    key: "business", icon: "Briefcase",
    it: { title: "Business Travel", desc: "Spostamenti di lavoro impeccabili: riservatezza, Wi-Fi a bordo e massima affidabilità." },
    en: { title: "Business Travel", desc: "Flawless corporate travel: confidentiality, on-board Wi-Fi and total reliability." },
  },
  {
    key: "weddings", icon: "Heart",
    it: { title: "Matrimoni", desc: "Auto di rappresentanza per il giorno più importante, con allestimenti su richiesta." },
    en: { title: "Weddings", desc: "Prestige cars for your most important day, with bespoke arrangements on request." },
  },
  {
    key: "events", icon: "Sparkles",
    it: { title: "Eventi", desc: "Logistica di trasporto per gala, congressi e cerimonie, curata nei minimi dettagli." },
    en: { title: "Events", desc: "Transport logistics for galas, conferences and ceremonies, managed to the finest detail." },
  },
  {
    key: "tours", icon: "MapPin",
    it: { title: "Tour Privati", desc: "Itinerari esclusivi lungo la costa e nell'entroterra, al ritmo che preferite." },
    en: { title: "Private Tours", desc: "Exclusive itineraries along the coast and inland, at the pace you prefer." },
  },
  {
    key: "concierge", icon: "Bell",
    it: { title: "Concierge di Lusso", desc: "Prenotazioni ristoranti, esperienze e assistenza personalizzata durante il vostro soggiorno." },
    en: { title: "Luxury Concierge", desc: "Restaurant bookings, experiences and personalised assistance throughout your stay." },
  },
  {
    key: "vip", icon: "Crown",
    it: { title: "Servizi VIP su Misura", desc: "Soluzioni completamente personalizzate per esigenze speciali e clientela d'élite." },
    en: { title: "Custom VIP Services", desc: "Fully bespoke solutions for special needs and an elite clientele." },
  },
];

export const fleet = [
  {
    key: "sclass", image: IMAGES.fleet1, seats: 3, bags: 3,
    it: { name: "Mercedes-Benz Classe S", tag: "Berlina di rappresentanza", desc: "L'apice del comfort executive: silenziosità, interni in pelle e tecnologia all'avanguardia." },
    en: { name: "Mercedes-Benz S-Class", tag: "Executive sedan", desc: "The peak of executive comfort: silence, leather interiors and cutting-edge technology." },
  },
  {
    key: "vclass", image: IMAGES.fleet2, seats: 7, bags: 7,
    it: { name: "Mercedes-Benz Classe V", tag: "Van luxury", desc: "Spazio e versatilità per famiglie e gruppi, senza rinunciare all'eleganza." },
    en: { name: "Mercedes-Benz V-Class", tag: "Luxury van", desc: "Space and versatility for families and groups, without sacrificing elegance." },
  },
];

export const destinations = [
  {
    key: "amalfi", image: IMAGES.amalfi,
    it: { name: "Costiera Amalfitana", desc: "Curve mozzafiato, borghi a picco sul mare e panorami che tolgono il fiato." },
    en: { name: "Amalfi Coast", desc: "Breathtaking curves, cliffside villages and views that take your breath away." },
  },
  {
    key: "sorrento", image: IMAGES.sorrento,
    it: { name: "Sorrento", desc: "Il fascino senza tempo della penisola sorrentina, tra agrumeti e terrazze sul golfo." },
    en: { name: "Sorrento", desc: "The timeless charm of the Sorrentine peninsula, among citrus groves and gulf terraces." },
  },
  {
    key: "capri", image: IMAGES.positano,
    it: { name: "Capri & Positano", desc: "Le perle esclusive del Mediterraneo, raggiungibili con il massimo comfort." },
    en: { name: "Capri & Positano", desc: "The exclusive pearls of the Mediterranean, reached in the utmost comfort." },
  },
  {
    key: "pompei", image: IMAGES.pompeii,
    it: { name: "Pompei & Napoli", desc: "Storia, cultura e arte, dai templi antichi al cuore pulsante della città." },
    en: { name: "Pompeii & Naples", desc: "History, culture and art, from ancient temples to the beating heart of the city." },
  },
];

export const serviceOptions = [
  { value: "airport", it: "Trasferimento Aeroporto/Stazione", en: "Airport/Station Transfer" },
  { value: "chauffeur", it: "Autista Privato", en: "Private Chauffeur" },
  { value: "business", it: "Business Travel", en: "Business Travel" },
  { value: "wedding", it: "Matrimonio", en: "Wedding" },
  { value: "event", it: "Evento", en: "Event" },
  { value: "tour", it: "Tour Privato", en: "Private Tour" },
  { value: "concierge", it: "Concierge di Lusso", en: "Luxury Concierge" },
  { value: "vip", it: "Servizio VIP", en: "VIP Service" },
];
